import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import EventsSection from '../components/EventsSection';
import NewspaperIcon from '@mui/icons-material/Newspaper';

const NewsPage = () => {
  return (
    <>
      <Header />
      <Box sx={{ py: 8, backgroundColor: '#f9f9f9' }}>
        <Container maxWidth="lg">
          
        </Container>
      </Box>
      <EventsSection />
      <Footer />
    </>
  );
};

export default NewsPage;
